module.exports = __webpack_public_path__ + "img/border_Form.be9d03f4.svg";